import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { ArticleCard } from "./ArticleCard";
import { sortedArticles } from "@/data/articles";

export const RiflessioniPreview = () => {
    const latest = sortedArticles().slice(0, 3);
    return (
        <section id="riflessioni" className="bg-cream" data-testid="riflessioni-preview-section">
            <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-20 md:py-28">
                <Reveal className="flex flex-wrap items-end justify-between gap-6">
                    <div className="max-w-2xl">
                        <Eyebrow>Il blog</Eyebrow>
                        <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl leading-snug text-ink" data-testid="riflessioni-preview-title">
                            Riflessioni
                        </h2>
                        <p className="mt-5 text-base sm:text-lg text-[#526063] leading-relaxed">
                            Pensieri e approfondimenti su psicologia, emozioni e consapevolezza.
                        </p>
                    </div>
                    <Link
                        to="/riflessioni"
                        data-testid="riflessioni-preview-all"
                        className="group inline-flex items-center gap-2 text-sm font-semibold text-petrol hover:text-petrol-soft transition-colors duration-300"
                    >
                        Tutte le riflessioni
                        <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
                    </Link>
                </Reveal>
                <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                    {latest.map((a, i) => (
                        <Reveal key={a.slug} delay={i * 0.1}>
                            <ArticleCard article={a} testid={`home-article-card-${a.slug}`} />
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
